import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { serializeCalendarState } from '@/js/core/utils/calendar-url-state';
import { ownsUrl } from '@/js/core/utils/modal-route';

export function useCalendarUrlState({ dstart, activeView, selectedFilters, showPastEvents }) {
  const route = useRoute();
  // Deep-link landings normalize the URL on mount; clean landings stay parameter-free.
  const hadInitialParams = window.location.search.length > 1;

  watch(
    [dstart, activeView, selectedFilters, showPastEvents],
    () => {
      if (!ownsUrl(route)) {
        return;
      }

      const qs = serializeCalendarState({
        dstart: dstart.value,
        view: activeView.value,
        includes_past_events: showPastEvents.value,
        filters: selectedFilters.value,
      });
      window.history.replaceState(window.history.state, '', `${window.location.pathname}?${qs}`);
    },
    { deep: true, immediate: hadInitialParams }
  );
}
